import { Table, Flex, Avatar, Pagination, Badge, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getEmployeeActivities } from "../../api/employeeApi";
import dayjs from "dayjs";
import styled from "styled-components";
import "dayjs/locale/tr";
import CustomDatePicker from "../common/Inputs/CustomDatePicker";
import CustomSelect from "../common/Inputs/CustomSelect";
import CustomPagination from "../common/CustomPagination";
dayjs.locale("tr");

const EmployeeDetailTable = () => {
  const { id } = useParams();
  const [tableData, setTableData] = useState<any>();

  const navigate = useNavigate();
  //for pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState<any>(
    window.devicePixelRatio === 1.25 ? "4" : "7"
  );
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  //for sort
  const [sort, setSort] = useState<any>("");
  //for select
  const [selectedActivity, setSelectedActivity] = useState<any>("");
  //for date
  const [formattedSelectedDate, setFormattedSelectedDate] = useState<any>("");
  const [selectedDate, setSelectedDate] = useState<any>();
  //dateinput ref

  const getTableData = async () => {
    try {
      const { data }: any = await getEmployeeActivities({
        pageNumber: page,
        limit: limit,
        sort,
        date: formattedSelectedDate,
        activity: selectedActivity,
        id: id,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
      setTotalItems(data?.meta?.total);
    } catch (error) {}
  };

  useEffect(() => {
    if (page) {
      getTableData();
    }
  }, [page, sort, selectedActivity, formattedSelectedDate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
      }}
    >
      <div
        style={{
          fontWeight: "600",
          color: "black",
          fontSize: "20px",
          lineHeight: "24px",
          marginBottom: "20px",
        }}
      >
        Çalışan Giriş Çıkış Detayları
      </div>

      <div
        style={{
          overflowY: "auto",
          minHeight: "max-content",
          width: "100%",
          border: "1px solid #D1D5DB",
          borderRadius: "6px",
        }}
      >
        <Flex p={"12px 16px"} justify={"space-between"}>
          <Flex gap={8}>
            <CustomDatePicker
              placeholder="Tarih Seçiniz"
              onChange={(e: any) => {
                setSelectedDate(e);
                setFormattedSelectedDate(
                  e ? dayjs(e).format("YYYY-MM-DD") : ""
                );
              }}
            />
          </Flex>
          <Flex>
            <CustomSelect
              placeholder="Giriş/Çıkış"
              data={["Giriş", "Çıkış"]}
              onChange={(e: any) => {
                setSelectedActivity(
                  e == "Giriş" ? 1 : e == "Çıkış" ? 2 : undefined
                );
                setPage(1);
              }}
            />
          </Flex>
        </Flex>
        <Table
          style={{
            borderCollapse: "separate",
          }}
          verticalSpacing="sm"
          horizontalSpacing="md"
        >
          <Table.Thead
            style={{
              background: "#EEF2FF",
            }}
          >
            <Table.Tr>
              <StyledTableTh style={{ width: "15%" }}>
                Giriş/Çıkış
              </StyledTableTh>
              <StyledTableTh style={{ width: "15%" }}>Saat</StyledTableTh>
              <StyledTableTh style={{ width: "15%" }}>
                <Flex
                  gap={4}
                  style={{
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setSort((prev: string) =>
                      prev === "desc" ? "asc" : "desc"
                    );
                  }}
                >
                  <div>Tarih</div>
                  {sort === "desc" ? (
                    <Avatar src={"/assets/ascSortIcon.png"} size={16} />
                  ) : (
                    <Avatar src={"/assets/descSortIcon.png"} size={16} />
                  )}
                </Flex>
              </StyledTableTh>
              <StyledTableTh style={{ width: "15%" }}>
                Tablet Kodu
              </StyledTableTh>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {tableData?.map((data: any) => (
              <Table.Tr key={data._id}>
                <Table.Td>
                  <Flex align={"center"} gap={16}>
                    <Badge
                      bg={data.action === 1 ? "#DBFFE5" : "#FFE8E9"}
                      size="40px"
                      circle
                    >
                      {data.action === 1 ? (
                        <Avatar src={"/assets/entryIcon.png"} size={24} />
                      ) : (
                        <Avatar src={"/assets/exitIcon.png"} size={24} />
                      )}
                    </Badge>
                    {data.action == 1 ? "Giriş" : "Çıkış"}
                  </Flex>
                </Table.Td>
                <Table.Td>
                  {new Date(data.date as Date).toLocaleTimeString(undefined, {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Table.Td>
                <Table.Td>{new Date(data.date).toLocaleDateString()}</Table.Td>
                <Table.Td>{data.terminalCode}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </div>

      <div
        style={{
          alignSelf: "center",
          position: "absolute",
          bottom: "-10px",
        }}
      >
        <CustomPagination total={totalPages} value={page} onChange={setPage} />
      </div>
    </div>
  );
};

export default EmployeeDetailTable;

const StyledTableTh = styled(Table.Th)<any>`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: #4c4c4c;
`;
